module.exports = __webpack_public_path__ + "static/media/adminLogoWithText.9ffa7bb6.svg";